export function DateInput({ id, value, onChange }) {
  return (
    <input
      type="date"
      id={id}
      value={value}
      onChange={(e) => onChange && onChange(e.target.value)}
    />
  );
}
